export function About() {
  return (
    <section id="about" className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          <div>
            <p className="text-emerald-600 font-semibold text-xs sm:text-sm tracking-wide uppercase mb-3 sm:mb-4">
              About Dr. Yousefi
            </p>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-4 sm:mb-6">
              Professional Biography
            </h2>
            <div className="space-y-3 sm:space-y-4 text-sm sm:text-base text-slate-600 leading-relaxed">
              <p>
                Dr. Arash Yousefi is a distinguished physician who is double board-certified by the American Board of Neurology and Psychiatry and the American Board of Interventional Pain Management. He completed his Neurology residency at the prestigious Mount Sinai Hospital in New York City, followed by a Clinical Research Fellowship in TBI and Stroke Rehabilitation at NYU. Dr. Yousefi further specialized in Interventional Pain Management through his fellowship at UC Davis.
              </p>
              <p>
                With over 30 published articles and book chapters to his name, Dr. Yousefi is recognized as a leading expert in his field. He currently serves as an attending physician and educator at Loma Linda University Hospital, where he trains the next generation of medical professionals while providing exceptional patient care.
              </p>
            </div>

            <div className="mt-6 sm:mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
              <div className="bg-slate-50 rounded-lg p-5 sm:p-6 border border-slate-200">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-emerald-500/10 rounded-full mb-3 sm:mb-4">
                  <i className="ri-award-line text-xl sm:text-2xl text-emerald-600"></i>
                </div>
                <h3 className="font-semibold text-slate-900 mb-2 text-sm sm:text-base">Board Certifications</h3>
                <p className="text-xs sm:text-sm text-slate-600">American Board of Neurology and Psychiatry & American Board of Interventional Pain Management</p>
              </div>

              <div className="bg-slate-50 rounded-lg p-5 sm:p-6 border border-slate-200">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-emerald-500/10 rounded-full mb-3 sm:mb-4">
                  <i className="ri-stethoscope-line text-xl sm:text-2xl text-emerald-600"></i>
                </div>
                <h3 className="font-semibold text-slate-900 mb-2 text-sm sm:text-base">Academic Role</h3>
                <p className="text-xs sm:text-sm text-slate-600">Attending Physician & Educator at Loma Linda University Hospital</p>
              </div>
            </div>
          </div>

          <div className="relative order-first lg:order-last">
            <div className="relative rounded-lg overflow-hidden shadow-2xl w-full h-[400px] sm:h-[500px] lg:h-[600px]">
              <img
                src="https://static.readdy.ai/image/23ade0805c842f9b7ab135282ab65771/f6feab119113084a4eb8b07ec3ddc8d7.jpeg"
                alt="Dr. Arash Yousefi"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}